<header class="header">
  <div class="kota-container header__inner">
    <a routerLink="/" class="header__logo" (click)="closeMenu()">
      <img src="assets/img/kota_logo.png" alt="KOTA" class="header__logo-img" />
    </a>

    <button
      type="button"
      class="header__menu-btn"
      [attr.aria-expanded]="menuOpen"
      aria-controls="kota-nav"
      (click)="toggleMenu()"
    >
      <span class="visually-hidden">Menú</span>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        @if (!menuOpen) {
          <path d="M4 6h16M4 12h16M4 18h16" />
        } @else {
          <path d="M18 6L6 18M6 6l12 12" />
        }
      </svg>
    </button>

    <nav id="kota-nav" class="header__nav" [class.header__nav--open]="menuOpen">
      @if (auth.isLoggedIn() && user(); as u) {
        <div class="header__nav-user">
          <div class="header__nav-user-avatar" aria-hidden="true">{{ userInitials() }}</div>
          <div class="header__nav-user-text">
            <p class="header__nav-user-name">Hola, {{ userFirstName() }}</p>
            <p class="header__nav-user-email">{{ u.email }}</p>
          </div>
        </div>
      }
      <a
        routerLink="/"
        routerLinkActive="header__nav-link--active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="header__nav-link"
        (click)="closeMenu()"
        >Inicio</a
      >
      <a
        routerLink="/catalogo"
        routerLinkActive="header__nav-link--active"
        class="header__nav-link"
        (click)="closeMenu()"
        >Catálogo</a
      >
      @if (auth.isLoggedIn()) {
        <a
          routerLink="/mi-cuenta/pedidos"
          routerLinkActive="header__nav-link--active"
          class="header__nav-link"
          (click)="closeMenu()"
          >Mis Pedidos</a
        >
      }
<a routerLink="/nosotros" class="header__nav-link" (click)="closeMenu()">Nosotros</a>
      @if (!auth.isLoggedIn()) {
        <a routerLink="/login" class="header__nav-link header__nav-link--login" (click)="closeMenu()">Iniciar sesión</a>
      } @else {
        <button type="button" class="header__nav-link header__nav-link--logout" (click)="logout($event)">
          Cerrar sesión
        </button>
      }
    </nav>

    <div class="header__actions">
      <a routerLink="/busqueda" class="header__icon-btn" aria-label="Buscar" (click)="closeMenu()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.3-4.3" />
        </svg>
      </a>
      @if (auth.isLoggedIn() && user(); as u) {
        <a
          routerLink="/mi-cuenta/pedidos"
          class="header__account"
          [attr.aria-label]="'Mi cuenta, ' + u.name"
          (click)="closeMenu()"
        >
          <span class="header__account-avatar" aria-hidden="true">{{ userInitials() }}</span>
          <span class="header__account-name">{{ userFirstName() }}</span>
        </a>
        <button
          type="button"
          class="header__icon-btn header__logout"
          aria-label="Cerrar sesión"
          (click)="logout($event)"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      } @else {
        <a routerLink="/login" class="header__login" (click)="closeMenu()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          <span class="header__login-text">Iniciar sesión</span>
        </a>
      }
      <a
        routerLink="/carrito"
        routerLinkActive="header__cart--active"
        class="header__cart"
        [class.header__cart--has-items]="cartCount() > 0"
        [attr.aria-label]="cartAriaLabel()"
        (click)="closeMenu()"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
          <path d="M3 6h18" />
          <path d="M16 10a4 4 0 0 1-8 0" />
        </svg>
        @if (cartCount() > 0) {
          <span
            class="header__cart-badge"
            [class.header__cart-badge--pulse]="cartBadgePulse()"
            aria-hidden="true"
          >{{ cartBadgeLabel() }}</span>
        }
      </a>
    </div>
  </div>
</header>
